<style scoped>
select option:disabled {
  color: antiquewhite;
}
</style>

<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
import { constants } from "crypto";
import moment from "moment";

import CustomerDateRangePicker from '@/components/CustomerDateRangePicker'
import VueCharts from "vue-chartjs";
import { Bar, Line } from "vue-chartjs";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import numeral from 'numeral';
import accounting from 'accounting-js';

export default {
  name: "Employee",
  components: {
    Pagination,
    ErrorComponent,
    Alert,
    CustomerDateRangePicker,
    VueTimepicker
  },
  data() {
    return {
      chartOptionsBar: {},
      date: {
        startDate: "",
        endDate: ""
      },
      time: "",
      period: "",
      isShow: false,
      myChart: "",
      demo: [],
      name: [],
      month: [],
      year: [],
      week: [],
      quarter: [],
      total_amount: [],
      count: [],
      amount: [],
      hours: [],
      grossdate: [],
      decimal_separator: ".",
      precision: 0,
      currency: "",
      currentPage: 1,
      totalPage: 0,
      itemsPerPage: 10,
      list: [],
      item_chart: ["name", "total_amount", "count", "date"],
      storeList: [],
      topItemList: [],
      employeeList: [],
      currentSorting: "",
      filterObj: {
        sort_by: "",
        order_by: "ASC",
        store_id: "",
        employee_id: "",
        search: "",
        to_date: "",
        from_date: "",
        to_time: "",
        from_time: "",
        type: "Days"
      },
      isHours: false,
      lineMyChart: "",
      isDays: true,
      isWeek: false,
      isMonth: false,
      isQuarter: false,
      isYear: false,
      graph: this.$lang.messages.line,
      data: []
    };
  },
  methods: {
    pageChange(page) {
      this.getList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(1);
    },
    getRandomColor() {
        var letters = '0123456789ABCDEF'.split('');
        var color = '#';
        for (var i = 0; i < 6; i++ ) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    },
    getList(page, sortBy, orderBy, store_id) {
      if (this.lineMyChart) {
        this.lineMyChart.destroy();
        this.lineMyChart = ""
      }

      this.total_amount = [];
      this.month = [];
      this.grossdate = [];
      this.year = [];
      this.week = [];
      this.quarter = [];
      this.hours = [];
      this.data = [];
      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        "Y-M-D"
      );

      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        "Y-M-D"
      );

      this.list = [];
      this.currentPage = page;

      if (sortBy) {
        this.filterObj.sort_by = sortBy;
      }
      if (orderBy) {
        this.filterObj.order_by = orderBy;
      }

      if (this.store_id) {
        this.filterObj.store_id = store_id;
      }

      if (this.search) {
        this.filterObj.search = search;
      }

      if (!this.filterObj.type) {
        this.filterObj.type = "Days";
      }
      this.$api
        .getAPI({
          _action: "/report/item/" + this.itemsPerPage + "/" + page,
          _body: this.filterObj,
          _hide_loader: true
        })
        .then(res => {
          this.list = res.list;
          this.topItemList = res.top_items;
          this.item_chart = res.item_chart;

          if (page == 1) {
            if (res.count != null && res.count > 0) {
              this.$refs.listPagination.setTotalCount(res.count);
            } else {
              this.$refs.listPagination.setTotalCount(0);
            }
          }

          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle(this.$lang.messages.no_items_found);
          } else if (this.$refs.errorComonent.isShowMessage()) {
            this.$refs.errorComonent.setTitle();
          }
          for (var i = 0; i < res.item_chart.length; i++) {
            this.data.push(res.item_chart[i].total_amount);

            if (this.filterObj.type == "Weeks") {
              this.week.push(res.item_chart[i].week);
            }
            if (this.filterObj.type == "Hours") {
              this.hours.push(res.item_chart[i].Hours);
            }
            if (this.filterObj.type == "Quarters") {
              this.quarter.push(res.item_chart[i].quarter);
            }
            if (this.filterObj.type == "Months") {
              this.month.push(res.item_chart[i].month);
            }
            if (this.filterObj.type == "Years") {
              this.year.push(res.item_chart[i].year);
            }
            if (this.filterObj.type == "Days") {
              this.grossdate.push(res.item_chart[i].date);
            }
          }
          if (this.myChart != "") {
            this.myChart.destroy();
          }

          if (this.filterObj.type == "Days") {
            if (this.graph == this.$lang.messages.bar) {
              var ctx = document.getElementById("lineChart").getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "bar",
                data: {
                  labels: this.grossdate,
                  datasets: [
                    {
                      label: this.$lang.messages.total_amount,
                      data: this.data,
                      borderColor: "#0000FF",
                      fill: true
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: true,
                          data: this.grossdate
                        },
                        callback: function(value, index, values) {
                          return numeral(value).format('0.0a');
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            } else if (this.graph == this.$lang.messages.pie) {
              var ctx = document.getElementById("lineChart").getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "doughnut",
                data: {
                  labels: this.grossdate,
                  datasets: [
                    {
                      label: this.$lang.messages.total_amount,
                      data: this.data.map(data => data != 0? data : undefined),
                      backgroundColor: this.data.map(data => this.getRandomColor()),
                    }
                  ]
                },
                options: {
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(chart.datasets[0].data[tooltipItem.index], accounting.settings);
                          }
                      }
                  }
                }
              });
            } else {
              var ctx = document.getElementById("lineChart").getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "line",
                data: {
                  labels: this.grossdate,
                  datasets: [
                    {
                      label: this.$lang.messages.total_amount,
                      data: this.data,
                      borderColor: "#f87979",
                      fill: false
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: true,
                          data: this.grossdate,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            }
          } else if (this.filterObj.type == "Hours") {
            if (this.graph == this.$lang.messages.bar) {
              var ctx = document.getElementById("lineChart").getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "bar",
                data: {
                  labels: this.hours,
                  datasets: [
                    {
                      label: this.$lang.messages.total_amount,
                      data: this.data,
                      borderColor: "#0000FF",
                      fill: false
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: true,
                          data: this.hours,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            } else if (this.graph == this.$lang.messages.pie) {
              var ctx = document.getElementById("lineChart").getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "doughnut",
                data: {
                  labels: this.hours,
                  datasets: [
                    {
                      label: this.$lang.messages.total_amount,
                      data: this.data.map(data => data != 0? data : undefined),
                      backgroundColor: this.data.map(data => this.getRandomColor()),
                    }
                  ]
                },
                options: {
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(chart.datasets[0].data[tooltipItem.index], accounting.settings);
                          }
                      }
                  }
                }
              });
            } else {
              var ctx = document.getElementById("lineChart").getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "line",
                data: {
                  labels: this.hours,
                  datasets: [
                    {
                      label: this.$lang.messages.total_amount,
                      data: this.data,
                      borderColor: "#f87979",
                      fill: false
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: true,
                          data: this.hours,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            }
          } else if (this.filterObj.type == "Weeks") {
            if (this.graph == this.$lang.messages.bar) {
              var ctx = document.getElementById("lineChart").getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "bar",
                data: {
                  labels: this.week,
                  datasets: [
                    {
                      label: this.$lang.messages.total_amount,
                      data: this.data,
                      borderColor: "#0000FF",
                      fill: false
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: true,
                          data: this.week,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            } else if (this.graph == this.$lang.messages.pie) {
              var ctx = document.getElementById("lineChart").getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "doughnut",
                data: {
                  labels: this.week,
                  datasets: [
                    {
                      label: this.$lang.messages.total_amount,
                      data: this.data.map(data => data != 0? data : undefined),
                      backgroundColor: this.data.map(data => this.getRandomColor()),
                    }
                  ]
                },
                options: {
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(chart.datasets[0].data[tooltipItem.index], accounting.settings);
                          }
                      }
                  }
                }
              });
            } else {
              var ctx = document.getElementById("lineChart").getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "line",
                data: {
                  labels: this.week,
                  datasets: [
                    {
                      label: this.$lang.messages.total_amount,
                      data: this.data,
                      borderColor: "#f87979",
                      fill: false
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: true,
                          data: this.week,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            }
          } else if (this.filterObj.type == "Months") {
            if (this.graph == this.$lang.messages.bar) {
              var ctx = document.getElementById("lineChart").getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "bar",
                data: {
                  labels: this.month,
                  datasets: [
                    {
                      label: this.$lang.messages.total_amount,
                      data: this.data,
                      borderColor: "#0000FF",
                      fill: false
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: true,
                          data: this.month,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            } else if (this.graph == this.$lang.messages.pie) {
              var ctx = document.getElementById("lineChart").getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "doughnut",
                data: {
                  labels: this.month,
                  datasets: [
                    {
                      label: this.$lang.messages.total_amount,
                      data: this.data.map(data => data != 0? data : undefined),
                      backgroundColor: this.data.map(data => this.getRandomColor()),
                    }
                  ]
                },
                options: {
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(chart.datasets[0].data[tooltipItem.index], accounting.settings);
                          }
                      }
                  }
                }
              });
            } else {
              var ctx = document.getElementById("lineChart").getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "line",
                data: {
                  labels: this.month,
                  datasets: [
                    {
                      label: this.$lang.messages.total_amount,
                      data: this.data,
                      borderColor: "#f87979",
                      fill: false
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: true,
                          data: this.month,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            }
          } else if (this.filterObj.type == "Quarters") {
            if (this.graph == this.$lang.messages.bar) {
              var ctx = document.getElementById("lineChart").getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "bar",
                data: {
                  labels: this.quarter,
                  datasets: [
                    {
                      label: this.$lang.messages.total_amount,
                      data: this.data,
                      borderColor: "#0000FF",
                      fill: false
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: true,
                          data: this.quarter,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            } else if (this.graph == this.$lang.messages.pie) {
              var ctx = document.getElementById("lineChart").getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "doughnut",
                data: {
                  labels: this.quarter,
                  datasets: [
                    {
                      label: this.$lang.messages.total_amount,
                      data: this.data.map(data => data != 0? data : undefined),
                      backgroundColor: this.data.map(data => this.getRandomColor()),
                    }
                  ]
                },
                options: {
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(chart.datasets[0].data[tooltipItem.index], accounting.settings);
                          }
                      }
                  }
                }
              });
            } else {
              var ctx = document.getElementById("lineChart").getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "line",
                data: {
                  labels: this.quarter,
                  datasets: [
                    {
                      label: this.$lang.messages.total_amount,
                      data: this.data,
                      borderColor: "#f87979",
                      fill: false
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: true,
                          data: this.quarter,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            }
          } else if (this.filterObj.type == "Years") {
            if (this.graph == this.$lang.messages.bar) {
              var ctx = document.getElementById("lineChart").getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "bar",
                data: {
                  labels: this.year,
                  datasets: [
                    {
                      label: this.$lang.messages.total_amount,
                      data: this.data,
                      borderColor: "#0000FF",
                      fill: false
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: false,
                          data: this.year,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            } else if (this.graph == this.$lang.messages.pie) {
              var ctx = document.getElementById("lineChart").getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "doughnut",
                data: {
                  labels: this.year,
                  datasets: [
                    {
                      label: this.$lang.messages.total_amount,
                      data: this.data.map(data => data != 0? data : undefined),
                      backgroundColor: this.data.map(data => this.getRandomColor()),
                    }
                  ]
                },
                options: {
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(chart.datasets[0].data[tooltipItem.index], accounting.settings);
                          }
                      }
                  }
                }
              });
            } else {
              var ctx = document.getElementById("lineChart").getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "line",
                data: {
                  labels: this.year,
                  datasets: [
                    {
                      label: this.$lang.messages.total_amount,
                      data: this.data,
                      borderColor: "#f87979",
                      fill: false
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: false,
                          data: this.year,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ],
                    xAxes: [
                      {
                        gridLines: {
                          display: true
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            }
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle();
        });
    },

    sorting(e, sortBy) {
      var orderBy = "ASC";
      var className = "sorting_asc";
      var classes = e.target.className;
      if (classes.includes("sorting_asc")) {
        className = "sorting_desc";
      }

      $(".sorting_asc").removeClass("sorting_asc");
      $(".sorting_desc").removeClass("sorting_desc");

      if (className == "sorting_asc") {
        $(e.target)
          .addClass("sorting_asc")
          .removeClass("sorting_desc");
        orderBy = "ASC";
      } else if (className == "sorting_desc") {
        $(e.target)
          .addClass("sorting_desc")
          .removeClass("sorting_asc");
        orderBy = "DESC";
      }
      this.getList(1, sortBy, orderBy);
    },
    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
          }
        })
        .catch(e => {});
    },
    getPeriod() {
      if (this.period == "Custom Period") {
        this.isShow = true;
      } else {
        this.filterObj.to_time = ""
        this.filterObj.from_time = ""
        this.isShow = false;
      }
    },
    getEmployeeList() {
      this.$api
        .getAPI({ _action: `/employee/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.employeeList = res.list;
          }
        })
        .catch(e => {});
    },
    retry() {
      this.getList(1);
    },
    getDifference() {
      var a = moment(this.date.startDate);
      var b = moment(this.date.endDate);

      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        "Y-MM-DD"
      );

      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        "Y-MM-DD"
      );

      this.isDays = false;
      this.isHours = false;
      this.isYear = false;
      this.isQuarter = false;
      this.isWeek = false;
      this.isMonth = false;

      if (b.diff(a, "days") == 0) {
        this.isHours = true;
        this.filterObj.type = "Hours";
      } else if (b.diff(a, "years") > 0) {
        this.isYear = true;
        this.filterObj.type = "Years";
      } else if (b.diff(a, "quarters") > 0) {
        this.isQuarter = true;
        this.filterObj.type = "Quarters";
      } else if (b.diff(a, "months") > 0) {
        this.isMonth = true;
        this.filterObj.type = "Months";
      } else if (b.diff(a, "days") > 9) {
        this.isWeek = true;
        this.filterObj.type = "Weeks";
      } else {
        this.isDays = true;
        this.filterObj.type = "Days";
      }

      this.getList(1);
    },
    getExport() {
      if (this.store_id) {
        this.filterObj.store_id = store_id;
      }

      if (this.search) {
        this.filterObj.search = search;
      }

      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        "Y-M-D"
      );

      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        "Y-M-D"
      );

      var queryParam = "";
      for (let key in this.filterObj) {
        if (queryParam == "") {
          queryParam += "?" + key + "=" + this.filterObj[key];
        } else {
          queryParam += "&" + key + "=" + this.filterObj[key];
        }
      }
      this.$api.getAndDownloadAPI({
        _action:
          "/report/export_item/" +
          localStorage.getItem("client_id") +
          queryParam,
        _fileName: "items.csv"
      });
    },
    colorCircleStyleGen(index){
      var colorArray = ['#F44236', '#008B8B', '#D2691E', '#006400', '#FFD700'];
      return {
        "font-size": "35px",
        "color": colorArray[index]
      }
    }
  },
  mounted() {
    if (localStorage.getItem("currency")) {
      this.currency = localStorage.getItem("currency");
    }

    this.decimal_separator = localStorage.getItem("decimal_separator") || ".";
    this.precision = (localStorage.getItem("decimal_separator") || "") == "" ? 0 : 2;

    accounting.settings = {
      symbol : "Rp",
      format: "%s %v",
      decimal : this.decimal_separator == ","? ".": ",",
      thousand: this.decimal_separator,
      precision : this.precision
    }

    this.getStoreList();
    this.getEmployeeList();
    this.getDifference();
  }
};
</script>
<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-md-12 d-lg-flex justify-content-end">
            <div class="date-range-picker-wrap d-flex mb-lg-0 mb-3 w-xs-100" style="width: 304px">
              <CustomerDateRangePicker
              class="w-xs-100"
              :date.sync="date"
              @update="getDifference()"></CustomerDateRangePicker>
            </div>
            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-2 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 180px;"
            >
              <select class="form-control" v-model="period" @change="getPeriod()">
                <option value>{{$lang.messages.all_day}}</option>
                <option>{{$lang.messages.custome_period}}</option>
              </select>
              <div
                class="text-center custom-select-dd d-inline-block mt-1 mb-2 w-xs-100 w-100"
                v-if="isShow"
              >
                <vue-timepicker
                  v-model="filterObj.to_time"
                  @change="getList(1)"
                  :placeholder="$lang.messages.start_time"
                  format="HH:mm"
                ></vue-timepicker>
              </div>
              <div
                class="text-center custom-select-dd d-inline-block mb-0 w-xs-100 w-100"
                v-if="isShow"
              >
                <vue-timepicker
                  v-model="filterObj.from_time"
                  @change="getList(1)"
                  :placeholder="$lang.messages.end_time"
                  format="HH:mm"
                ></vue-timepicker>
              </div>
            </div>
            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 180px;"
            >
              <select v-model="filterObj.store_id" @change="getList(1)" class="form-control">
                <option value>{{$lang.messages.all_stores}}</option>
                <option v-for="store in storeList" :key="store.id" :value="store.id">{{store.name}}</option>
              </select>
            </div>
            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 mllg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 180px;"
            >
              <select v-model="filterObj.employee_id" @change="getList(1)" class="form-control">
                <option value>{{$lang.messages.all_employees}}</option>
                <option
                  v-for="employee in employeeList"
                  :key="employee.id"
                  :value="employee.id"
                >{{employee.name}}</option>
              </select>
            </div>
          </div>
        </div>
        <!-- <div class="text-right row mb-3">
          <div class="text-right col-md-6">

          </div>

        </div>-->

        <div class="row">
          <div class="col-md-5">
            <div class="card rounded-5">
              <div class="card-body">
                <div class="pink-tape py-3">
                  <h3 class="font-22 mb-0">{{$lang.messages.Top_5_items}}</h3>
                  <div class="table-responsive">
                    <table class="table table-striped table-style-1">
                      <thead>
                        <tr>
                          <th scope="col" width="80" style="min-width:70px"></th>
                          <th scope="col">{{$lang.messages.name}}</th>
                          <th scope="col">{{$lang.messages.net_sales}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in topItemList" :key="item.id">
                          <td class="py-2">
                            <i class="fas fa-circle" :style="colorCircleStyleGen(index)"></i>
                          </td>
                          <td>{{item.name}}</td>
                          <td>
                            <vue-numeric
                              v-bind:precision="precision"
                              :separator="decimal_separator"
                              :currency="currency"
                              :value="item.total_amount"
                              :read-only="true"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-7">
            <div class="card rounded-5">
              <div class="card-body">
                <div class="pink-tape py-lg-1">
                  <div class="row">
                    <div class="col-lg-12 align-self-center">
                      <h3 class="font-22 mb-3 mt-2">{{$lang.messages.sales_by_item_chart}}</h3>
                      <div class="col-lg-8">
                        <div class="row">
                          <div class="col-4">
                            <div class="form-group mb-0">
                              <div class="custom-select-dd dd-transparent">
                                <select v-model="graph" class="form-control" @change="getList(1)">
                                  <option :selected="graph">{{$lang.messages.line}}</option>
                                  <option :selected="graph">{{$lang.messages.bar}}</option>
                                  <option :selected="graph">{{$lang.messages.pie}}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="col-4">
                            <div class="custom-select-dd dd-transparent">
                              <select
                                v-model="filterObj.type"
                                class="form-control"
                                @change="getList(1)"
                              >
                                <option
                                  value="Hours"
                                  :disabled="!isHours"
                                  :selected="filterObj.type"
                                >{{$lang.messages.hours}}</option>
                                <option
                                  value="Days"
                                  :disabled="(isHours || isQuarter || isYear)"
                                  :selected="filterObj.type"
                                >{{$lang.messages.days}}</option>
                                <option
                                  value="Weeks"
                                  :disabled="(isHours || isDays || isYear)"
                                  :selected="filterObj.type"
                                >{{$lang.messages.week}}</option>
                                <option
                                  value="Months"
                                  :disabled="(isHours || isDays || isWeek)"
                                  :selected="filterObj.type"
                                >{{$lang.messages.month}}</option>
                                <option
                                  value="Quarters"
                                  :disabled="(isHours || isDays || isWeek || isMonth)"
                                  :selected="filterObj.type"
                                >{{$lang.messages.quarter}}</option>
                                <option
                                  value="Years"
                                  :disabled="!isYear"
                                  :selected="filterObj.type"
                                >{{$lang.messages.year}}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div>
                        <canvas
                          id="lineChart"
                          width="90"
                          height="100"
                          style="display: block; height: 100px; width: 100px;"
                          class="chartjs-render-monitor"
                        ></canvas>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="card rounded-5">
              <div class="pink-tape py-1 mt-3">
                <div class="row">
                  <div class="col-lg-9 col-5 align-self-center">
                    <a
                      href="javascript:void(0)"
                      class="font-20 mb-0 text-regular text-hover-primary text-nowrap"
                      @click="getExport()"
                    >
                      {{$lang.messages.export}}
                      <i class="mdi mdi-download align-text-top"></i>
                    </a>
                  </div>
                </div>
              </div>

              <div class="card-body table-responsive">
                <table class="table table-striped table-style-1">
                <thead>
                  <tr>
                    <th scope="col">Sr.no</th>
                    <th
                      scope="col"
                      class="sorting"
                      @click="sorting($event, 'name')"
                    >{{$lang.messages.item}}</th>
                    <th
                      scope="col"
                      class="sorting"
                      @click="sorting($event, 'sku')"
                    >{{$lang.messages.sku}}</th>
                    <th
                      scope="col"
                      class="sorting"
                      @click="sorting($event, 'category_name')"
                    >{{$lang.messages.category_name}}</th>
                    <th
                      scope="col"
                      class="text-center sorting"
                      @click="sorting($event, 'item_sold')"
                    >{{$lang.messages.item_sold}}</th>
                    <th
                      scope="col"
                      class="text-center sorting"
                      @click="sorting($event, 'gross_sale')"
                    >{{$lang.messages.gross_sale}}</th>
                    <th
                      scope="col"
                      class="text-center"
                    >{{$lang.messages.item_refunded}}</th>
                    <th
                      scope="col"
                      class="text-center"
                    >{{$lang.messages.refunds}}</th>
                    <th
                      scope="col"
                      class="text-center sorting"
                      @click="sorting($event, 'discounts')"
                    >{{$lang.messages.discount}}</th>
                    <th
                      scope="col"
                      class="text-center sorting"
                      @click="sorting($event, 'net_sale')"
                    >{{$lang.messages.net_sale}}</th>
                    <th
                      scope="col"
                      class="text-center sorting"
                      @click="sorting($event, 'cost_of_good')"
                    >{{$lang.messages.cost_of_good}}</th>
                    <th
                      scope="col"
                      class="text-center"
                    >{{$lang.messages.gross_profit}}</th>
                    <th
                      scope="col"
                      class="text-center"
                    >{{$lang.messages.margin}}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(item, index) in list">
                    <tr :key="'item_'  +index">
                      <td>{{(currentPage -1) * itemsPerPage + index +1}}</td>
                      <td>{{item.name}}</td>
                      <td>{{item.sku ? item.sku : '-'}}</td>
                      <td>{{item.category_name ? item.category_name : '-'}}</td>
                      <td class="text-center">{{item.item_sold}}</td>
                      <td class="text-center">
                        <vue-numeric
                          v-if="item.gross_sale"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item.gross_sale"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                      <td class="text-center">{{item.items_refund}}</td>
                      <td class="text-center">
                        <vue-numeric
                          v-if="item.refunds"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item.refunds"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                      <td class="text-center">
                        <vue-numeric
                          v-if="item.discounts"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item.discounts"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                      <td class="text-center">
                        <vue-numeric
                          v-if="item.net_sale"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item.net_sale"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                      <td class="text-center">
                        <vue-numeric
                          v-if="item.cost_of_good"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item.cost_of_good"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                      <td class="text-center">
                        <vue-numeric
                          v-if="item.gross_profit"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item.gross_profit"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                      <td class="text-center">{{item.margin ? item.margin +" %" : "-"}}</td>
                    </tr>
                    <tr
                      :key="'var_'  +index+'_'+i"
                      v-for="(item_variant , i) in item.item_variant_combination"
                    >
                      <td class></td>
                      <td class>{{item_variant.value}}</td>
                      <td>{{item_variant.sku ? item_variant.sku : '-'}}</td>
                      <td>{{item_variant.category_name ? item_variant.category_name : '-'}}</td>
                      <td class="text-center">{{item_variant.item_sold}}</td>
                      <td class="text-center">
                        <vue-numeric
                          v-if="item_variant.gross_sale"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item_variant.gross_sale"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                      <td class="text-center">{{item_variant.items_refund}}</td>
                      <td class="text-center">
                        <vue-numeric
                          v-if="item_variant.refunds"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item_variant.refunds"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                      <td class="text-center">
                        <vue-numeric
                          v-if="item_variant.discounts"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item_variant.discounts"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                      <td class="text-center">
                        <vue-numeric
                          v-if="item_variant.net_sale"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item_variant.net_sale"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                      <td class="text-center">
                        <vue-numeric
                          v-if="item_variant.cost_of_good"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item_variant.cost_of_good"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                      <td class="text-center">
                        <vue-numeric
                          v-if="item_variant.gross_profit"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item_variant.gross_profit"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                      <td class="text-center">{{item_variant ? item_variant.margin +" %" : "-"}}</td>
                      <td class="text-center">
                        <vue-numeric
                          v-if="item_variant.taxes"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item_variant.taxes"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                    </tr>
                  </template>
                </tbody>
                </table>
              </div>
            </div>

            <ErrorComponent @retry="retry()" ref="errorComonent" />
            <div class="page-bottom-pagination text-right">
              <Pagination
                @page-change="pageChange"
                @items-per-page-change="itemsPerPageChange()"
                ref="listPagination"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
